import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled, { createGlobalStyle } from 'styled-components';
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContextProvider";
import axios from "axios";
import { customToast } from "../../../../../../../components/toast/custom-react-toastify/v1";
import { useEffect, useState } from "react";

import 'handsontable/styles/handsontable.min.css';
import 'handsontable/styles/ht-theme-main.min.css';
import Handsontable from 'handsontable/base';
import { registerAllModules } from 'handsontable/registry';
import { HotTable } from '@handsontable/react-wrapper';
import { ContextMenu } from "handsontable/plugins";
import { registerRenderer, textRenderer } from "handsontable/renderers";
import { LuArrowRight } from "react-icons/lu";
import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";

const StyledBody = styled.div`
    padding: 10px;

    .table-group{
        display: flex;
        flex-direction: row;
        gap: 10px;

        .arrow-icon{
            display:flex;
            align-items: center;
        }

        @media all and (max-width:992px){
            flex-direction: column;

            .arrow-icon{
                display: none;
            }
        }
    }

    h1{
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 10px;
        text-align: center;
    }

    h2{
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 5px;
    }

    .extra-info-box{
        margin-top: 10px;
        font-size: 14px;
    }
`;

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

const GlobalStyle = createGlobalStyle`
  .htContextMenu,
  .handsontable .context-menu-list {
      z-index: 1500 !important;
    }
`;

registerAllModules();
export function BackupRackLocationModal({
    open,
    onClose,
    editTargetPallet,
    pallets,
    loadItems,
    onReqFetch,
    apiResource = 'pallets',
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [rackLocations, setRackLocations] = useState(null);
    const [prevBackupRackLocationWrapper, setPrevBackupRackLocationWrapper] = useState(null);
    const [prevMergeBackupRackLocationWrapper, setPrevMergeBackupRackLocationWrapper] = useState(null);
    const currentRackLocation = rackLocations?.find(rack => rack.address === editTargetPallet?.rackLocationAddress);
    const currentMergeRackLocationAddress = (editTargetPallet?.childRackLocationAddresses && editTargetPallet?.childRackLocationAddresses?.length > 0) ? editTargetPallet?.childRackLocationAddresses[0] : null;
    const currentMergeRackLocation = rackLocations?.find(rack => rack.address === currentMergeRackLocationAddress);

    useEffect(() => {
        handleReqFetchRackLocations();
    }, [])

    useEffect(() => {
        if (!currentRackLocation?.prevBackupRackLocationId) {
            return;
        }

        handleReqFetchPrevRackLocation();
    }, [currentRackLocation?.prevBackupRackLocationId]);

    useEffect(() => {
        if (!currentMergeRackLocation?.prevBackupRackLocationId) {
            return;
        }

        handleReqFetchPrevMergeRackLocation();
    }, [currentMergeRackLocation?.prevBackupRackLocationId]);

    const handleReqFetchRackLocations = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        });

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        };

        const fetchResponse = await axios.get(`${API_HOST}/rack-locations`, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })


        setRackLocations(fetchResponse?.content);
    }

    const handleReqFetchPrevRackLocation = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        });

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        };

        const fetchResponse = await axios.get(`${API_HOST}/backup-rack-locations/${currentRackLocation?.prevBackupRackLocationId}`, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (fetchResponse?.content) {
            setPrevBackupRackLocationWrapper(fetchResponse?.content);
        }
    }

    const handleReqFetchPrevMergeRackLocation = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        });

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        };

        const fetchResponse = await axios.get(`${API_HOST}/backup-rack-locations/${currentMergeRackLocation?.prevBackupRackLocationId}`, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (fetchResponse?.content) {
            setPrevMergeBackupRackLocationWrapper(fetchResponse?.content);
        }
    }

    const handleReqRollbackRackLocation = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        });

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        };

        const body = {
            pallet: editTargetPallet
        }
        CustomBackdropController().showBackdrop();
        const rollbackResponse = await axios.post(`${API_HOST}/${apiResource}/rollback-rack-location-one`, body, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        await onReqFetch();
        onClose();
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <GlobalStyle />
            <CustomDialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                fullWidth
            >
                <CustomDialog.Header style={{ padding: 10 }}>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>
                        백업
                    </CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={onClose} />
                </CustomDialog.Header>
                <StyledBody>
                    <div style={{ border: '1px solid #efefef', padding: 10 }}>
                        <h1>로케이션 상태 ({currentRackLocation?.address})</h1>
                        <div className='table-group'>
                            {currentRackLocation &&
                                <div style={{ flex: 1, minWidth: '200px' }}>
                                    <h2>현재</h2>
                                    <div className="ht-theme-main-dark-auto">
                                        <HotTable
                                            data={(currentRackLocation?.items && currentRackLocation?.items?.length > 0) ? currentRackLocation?.items : [['-', '-', '-', '-', '-', '-']]}
                                            rowHeaders={true}
                                            colHeaders={HEADERS.map(header => header.label)}
                                            width="100%"
                                            height="200px"
                                            autoWrapRow={true}
                                            autoWrapCol={true}
                                            hiddenColumns={{
                                                columns: [0],
                                                // indicators: true,
                                            }}
                                            contextMenu={false}
                                            readOnly={true}
                                            licenseKey="non-commercial-and-evaluation" // for non-commercial use only
                                        />
                                    </div>
                                    <div className='extra-info-box'>
                                        <div>
                                            <span>타입:</span>
                                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{currentRackLocation?.type}</span>
                                        </div>
                                        <div>
                                            <span>링크 투 로케이션:</span>
                                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{currentRackLocation?.linkToLocationAddress ? currentRackLocation?.linkToLocationAddress : '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            <span className='arrow-icon'>
                                <LuArrowRight />
                            </span>
                            <div style={{ flex: 1, minWidth: '200px' }}>
                                <h2>복원후</h2>
                                {prevBackupRackLocationWrapper ?
                                    <>
                                        <div className="ht-theme-main-dark-auto">
                                            <HotTable
                                                data={(prevBackupRackLocationWrapper?.rackLocation?.items && prevBackupRackLocationWrapper?.rackLocation?.items?.length > 0) ? prevBackupRackLocationWrapper?.rackLocation?.items : [['-', '-', '-', '-', '-', '-']]}
                                                rowHeaders={true}
                                                colHeaders={HEADERS.map(header => header.label)}
                                                width="100%"
                                                height="200px"
                                                autoWrapRow={true}
                                                autoWrapCol={true}
                                                hiddenColumns={{
                                                    columns: [0],
                                                    // indicators: true,
                                                }}
                                                contextMenu={false}
                                                readOnly={true}
                                                licenseKey="non-commercial-and-evaluation" // for non-commercial use only
                                            />
                                        </div>
                                        <div className='extra-info-box'>
                                            <div>
                                                <span>타입:</span>
                                                <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{prevBackupRackLocationWrapper?.rackLocation?.type}</span>
                                            </div>
                                            <div>
                                                <span>링크 투 로케이션:</span>
                                                <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{prevBackupRackLocationWrapper?.rackLocation?.linkToLocation ? prevBackupRackLocationWrapper?.rackLocation?.linkToLocation : '-'}</span>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <div style={{ height: '300px' }}>백업 버전이 없습니다.</div>
                                }
                            </div>
                        </div>
                    </div>
                    {(editTargetPallet?.childRackLocationAddresses && editTargetPallet?.childRackLocationAddresses?.length > 0) &&
                        <>
                            <hr style={{ marginTop: '20px', marginBottom: '20px' }} />
                            <div>
                                <h1>병렬 로케이션 상태 ({currentMergeRackLocation?.address})</h1>
                                <div className='table-group'>
                                    {currentMergeRackLocation &&
                                        <div style={{ flex: 1, minWidth: '200px' }}>
                                            <h2>현재</h2>
                                            <div className="ht-theme-main-dark-auto">
                                                <HotTable
                                                    data={(currentMergeRackLocation?.items && currentMergeRackLocation?.items?.length > 0) ? currentMergeRackLocation?.items : [['-', '-', '-', '-', '-', '-']]}
                                                    rowHeaders={true}
                                                    colHeaders={HEADERS.map(header => header.label)}
                                                    width="100%"
                                                    height="200px"
                                                    autoWrapRow={true}
                                                    autoWrapCol={true}
                                                    hiddenColumns={{
                                                        columns: [0],
                                                        // indicators: true,
                                                    }}
                                                    contextMenu={false}
                                                    readOnly={true}
                                                    licenseKey="non-commercial-and-evaluation" // for non-commercial use only
                                                />
                                            </div>
                                            <div className='extra-info-box'>
                                                <div>
                                                    <span>타입:</span>
                                                    <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{currentMergeRackLocation?.type}</span>
                                                </div>
                                                <div>
                                                    <span>링크 투 로케이션:</span>
                                                    <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{currentMergeRackLocation?.linkToLocationAddress ? currentMergeRackLocation?.linkToLocationAddress : '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <span className='arrow-icon'>
                                        <LuArrowRight />
                                    </span>
                                    <div style={{ flex: 1, minWidth: '200px' }}>
                                        <h2>복원후</h2>
                                        {prevMergeBackupRackLocationWrapper ?
                                            <>
                                                <div className="ht-theme-main-dark-auto">
                                                    <HotTable
                                                        data={(prevMergeBackupRackLocationWrapper?.rackLocation?.items && prevMergeBackupRackLocationWrapper?.rackLocation?.items?.length > 0) ? prevMergeBackupRackLocationWrapper?.rackLocation?.items : [['-', '-', '-', '-', '-', '-']]}
                                                        rowHeaders={true}
                                                        colHeaders={HEADERS.map(header => header.label)}
                                                        width="100%"
                                                        height="200px"
                                                        autoWrapRow={true}
                                                        autoWrapCol={true}
                                                        hiddenColumns={{
                                                            columns: [0],
                                                            // indicators: true,
                                                        }}
                                                        contextMenu={false}
                                                        readOnly={true}
                                                        licenseKey="non-commercial-and-evaluation" // for non-commercial use only
                                                    />
                                                </div>
                                                <div className='extra-info-box'>
                                                    <div>
                                                        <span>타입:</span>
                                                        <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{prevMergeBackupRackLocationWrapper?.rackLocation?.type}</span>
                                                    </div>
                                                    <div>
                                                        <span>링크 투 로케이션:</span>
                                                        <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{prevMergeBackupRackLocationWrapper?.rackLocation?.linkToLocationAddress ? prevMergeBackupRackLocationWrapper?.rackLocation?.linkToLocationAddress : '-'}</span>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <div style={{ height: '300px' }}>백업 버전이 없습니다.</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    <div style={{ marginTop: '20px' }}>
                        <CustomBlockButton
                            type='button'
                            onClick={() => { handleReqRollbackRackLocation() }}
                            style={{ background: '#333', color: '#fff' }}
                        >
                            백업실행
                        </CustomBlockButton>
                    </div>
                </StyledBody>
            </CustomDialog>
        </>
    );
}

const HEADERS = [
    {
        key: 'uuid',
        label: 'UUID'
    },
    {
        key: 'productName',
        label: '상품명'
    },
    {
        key: 'optionName',
        label: '옵션명'
    },
    {
        key: 'boxQuantity',
        label: '박스수량'
    },
    {
        key: 'productQuantity',
        label: '상품수량'
    },
    {
        key: 'optionCode',
        label: '옵션코드'
    },
];